module.exports = (__webpack_require__(1))(38);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/actions/navTo.js from dll-reference rlink_core
// module id = 38
// module chunks = 0